import { useState } from 'react';

import { Badge } from 'antd';
import { Icon, Row, Tooltip } from 'farmhub-ui-core';

import { TagOption } from 'components';
import {
  CreateTagModal,
  ViewTagModal,
} from 'containers/WarehouseOperation/WorkSpace/components';
import { theme } from 'styled';
import { ICONS } from 'utils';

import { AddButton, Wrapper } from './styles';

interface EditableTagGroupProps {
  id?: string;
  name?: string;
  tags: any[];
  editAble?: boolean;
  type?: 'PRODUCT' | 'ORDER' | 'ENTITY';
  maxWidth?: string;
  onAfterSubmit?: (
    e: any[],
    deletedOptionIDs?: string[],
    typeOptions?: any[]
  ) => void;
}

const EditableTagGroup = ({
  id,
  name,
  tags,
  editAble,
  type = 'PRODUCT',
  maxWidth = '180px !important',
  onAfterSubmit,
}: EditableTagGroupProps): JSX.Element => {
  const [isVisibleCreateTagModal, setIsVisibleCreateTagModal] = useState(false);

  const handleAfterSubmit = (
    options: any[],
    deletedOptionIDs?: string[],
    typeOptions?: any[]
  ): void => {
    onAfterSubmit && onAfterSubmit(options, deletedOptionIDs, typeOptions);
  };

  return (
    <Wrapper>
      {editAble ? (
        <CreateTagModal
          id={id}
          initOptions={tags}
          isVisible={isVisibleCreateTagModal}
          name={name}
          setIsVisible={setIsVisibleCreateTagModal}
          type={type}
          onAfterSubmit={handleAfterSubmit}
        />
      ) : (
        <ViewTagModal
          id={id}
          initOptions={tags}
          isVisible={isVisibleCreateTagModal}
          name={name}
          setIsVisible={setIsVisibleCreateTagModal}
          type={type}
        />
      )}
      <Row alignItems="flex-start" styles={{ gap: 6 }}>
        {(tags?.slice(0, 2) || []).map((tag: any, index: number) => (
          <Tooltip title={tag?.content}>
            <div>
              <TagOption
                color={tag?.color?.code}
                label={tag?.content}
                styles={{
                  'max-width': maxWidth,
                }}
                onClick={() => setIsVisibleCreateTagModal(true)}
              />
            </div>
          </Tooltip>
        ))}
        {tags?.length > 2 && (
          <Row
            width="fit-content"
            onClick={() => setIsVisibleCreateTagModal(true)}
          >
            <Badge
              count={`+${tags?.length - 2}`}
              style={{ fontWeight: theme.font.weight.medium }}
            />
          </Row>
        )}
        {editAble && type !== 'ENTITY' && (
          <Tooltip title="Thêm nhãn">
            <AddButton
              onClick={() => (editAble ? setIsVisibleCreateTagModal(true) : 0)}
            >
              <Icon
                svgProps={{
                  icon: ICONS.PLUS,
                  width: '8px',
                  height: '8px',
                  color: '#fff',
                }}
              />
            </AddButton>
          </Tooltip>
        )}

        {editAble && type === 'ENTITY' && tags?.length === 0 && (
          <Tooltip title="Thêm nhãn">
            <AddButton
              className="add-tag"
              onClick={e => {
                e.stopPropagation();
                setIsVisibleCreateTagModal(true);
              }}
            >
              <Icon
                svgProps={{
                  icon: ICONS.PLUS,
                  width: '8px',
                  height: '8px',
                  color: '#fff',
                }}
              />
            </AddButton>
          </Tooltip>
        )}
      </Row>
    </Wrapper>
  );
};

export default EditableTagGroup;
